import { useCallback, useState } from 'react';

export function useBusinessSearch(resetPagination: () => void) {
  const [draftSearch, setDraftSearch] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const applySearch = useCallback(() => {
    setSearchQuery(draftSearch.trim());
    resetPagination();
  }, [draftSearch, resetPagination]);

  const clearSearch = useCallback(() => {
    setDraftSearch('');
    setSearchQuery('');
    resetPagination();
  }, [resetPagination]);

  return { draftSearch, setDraftSearch, searchQuery, applySearch, clearSearch };
}
